/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_Headline_PrefixInputs */

const en_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change your`)
};

const de_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veraendere deinen`)
};

const fr_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transforme ton`)
};

const es_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia tu`)
};

const it_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trasforma il tuo`)
};

const nl_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verander je`)
};

const pl_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zmień swoje`)
};

const fi_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muuta`)
};

const da_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forandr dit`)
};

const sv_landing_hero_headline_prefix = /** @type {(inputs: Landing_Hero_Headline_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förändra ditt`)
};

/**
* | output |
* | --- |
* | "Change your" |
*
* @param {Landing_Hero_Headline_PrefixInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_hero_headline_prefix = /** @type {((inputs?: Landing_Hero_Headline_PrefixInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_Headline_PrefixInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_hero_headline_prefix(inputs)
	if (locale === "fr") return fr_landing_hero_headline_prefix(inputs)
	if (locale === "es") return es_landing_hero_headline_prefix(inputs)
	if (locale === "it") return it_landing_hero_headline_prefix(inputs)
	if (locale === "nl") return nl_landing_hero_headline_prefix(inputs)
	if (locale === "pl") return pl_landing_hero_headline_prefix(inputs)
	if (locale === "fi") return fi_landing_hero_headline_prefix(inputs)
	if (locale === "da") return da_landing_hero_headline_prefix(inputs)
	if (locale === "sv") return sv_landing_hero_headline_prefix(inputs)
	return en_landing_hero_headline_prefix(inputs)
});